export default class {

  constructor (selector) {
    this.$el = $(selector)
  }

  init () {
    this.$el.on('click', (e) => {
      let $btn = $(e.currentTarget)
      let type = $btn.data('type')
      let $input = $btn.parent().find('input.qty')
      if (!$input) {
        return
      }
      let val = parseInt($input.val())
      if (!val) {
        val = 0
      }
      if (type === 'increment') {
        val++
      } else if (type === 'decrement') {
        val--
      }
      $input.val(val)
      $input.trigger('change')
    })
  }

}



// WEBPACK FOOTER //
// ./scripts/components/quantity.js